export const projects = [
    {
        tech: "Javascript",
        techThumbnailSrc: "/assets/images/javascript-icon.svg",
        title: "PolyShapr",
        description: "A webapp for creating polyrhythm animations, specifically using nested polygons. I went viral on instagram with this one!",
        href: "https://github.com/apc518/polyshapr"
    },
    {
        tech: "Rust",
        techThumbnailSrc: "/assets/images/rust-lang-icon.svg",
        title: "Realisr 2",
        description: "A sound design app similar in effect to granular synthesis but with an entirely novel interface and theoretical underpinning",
        href: "https://github.com/apc518/realisr-2"
    },
    {
        tech: "C#",
        techThumbnailSrc: "/assets/images/c-sharp-icon.svg",
        title: "Chess Engine",
        description: "A C# chess engine. I used a library for move generation and the rules of the game, but I coded the negamax algorithm, alpha-beta pruning, and multi-threading.",
        href: "https://github.com/apc518/parallel-chess"
    },
    {
        tech: "Python",
        techThumbnailSrc: "/assets/images/python-icon.svg",
        title: "Profanity Detector",
        description: "A surprisingly capable profanity detector written in pure python. It outperforms most profanity detectors I've seen in production.",
        href: "https://github.com/apc518/pyprofanity"
    },
    {
        tech: "C",
        techThumbnailSrc: "/assets/images/c-icon.svg",
        title: "UPS Shell",
        description: "A POSIX-style shell written in C, themed for my university, the University of Puget Sound",
        href: "https://github.com/apc518/ups-shell"
    },
    // {
    //     tech: "Python",
    //     techThumbnailSrc: "/assets/images/python-icon.svg",
    //     title: "Realisr",
    //     description: "A sound design tool based on a concept of 2-dimensional time signatures that I've explored over the past few years.",
    //     href: "https://chamberlainmusic.herokuapp.com/realisr"
    // },
    {
        tech: "Javascript",
        techThumbnailSrc: "/assets/images/javascript-icon.svg",
        title: "Context Collapse",
        description: "A 2D shooter game I made during the summer of 2021, featuring a cat in space shooting minecraft arrows. It also has a live leaderboard!",
        href: "https://chambercode.com/games/context-collapse"
    }
]